import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export const DarkCard = ({ title, hint, right, children, testId }) => (
  <div className="rounded-xl border border-white/10 bg-[#1f1f1f] p-5" data-testid={testId}>
    <div className="mb-5 flex items-center justify-between gap-3">
      <h3 className="text-[11px] font-medium uppercase tracking-wider text-neutral-400">{title}</h3>
      {right || <span className="text-[11px] text-neutral-500">{hint}</span>}
    </div>
    {children}
  </div>
);

export const RankedList = ({ items, testId, limit = 5, empty = 'No activity in this range' }) => {
  const [open, setOpen] = useState(false);
  if (!items.length) return <p className="py-8 text-center text-sm text-neutral-500">{empty}</p>;
  const shown = open ? items : items.slice(0, limit);
  return (
    <div data-testid={testId}>
      <div className="flex flex-col gap-6 py-1">
        {shown.map((it) => (
          <button
            key={it.key}
            type="button"
            onClick={it.onClick}
            disabled={!it.onClick}
            data-testid={`${testId}-item-${it.key}`}
            className="group block w-full text-left disabled:cursor-default"
          >
            <div className="mb-3 flex items-center justify-between gap-3 leading-6">
              <span className="flex min-w-0 items-center gap-2 text-sm font-medium text-neutral-100 group-enabled:group-hover:text-[#7ee8e2]">
                {it.icon}
                <span className="truncate">{it.label}</span>
                {it.sub && <span className="truncate text-xs font-normal text-neutral-500">{it.sub}</span>}
              </span>
              <span className="shrink-0 text-xs tabular-nums text-neutral-400">{it.value}</span>
            </div>
            <div className="h-1.5 rounded-full bg-white/10">
              <div className="h-1.5 rounded-full bg-[#7ee8e2] transition-[width] duration-500" style={{ width: `${it.pct}%` }} />
            </div>
          </button>
        ))}
      </div>
      {items.length > limit && (
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          data-testid={`${testId}-show-more`}
          className="mx-auto mt-4 flex items-center gap-1 text-[11px] font-medium uppercase tracking-wider text-neutral-500 hover:text-neutral-300"
        >
          {open ? 'Show less' : 'Show more'}
          <ChevronDown className={`h-3 w-3 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
      )}
    </div>
  );
};

export const CardToggle = ({ options, value, onChange, testId }) => (
  <div className="flex gap-0.5 rounded-md bg-white/5 p-0.5">
    {options.map(([k, l]) => (
      <button
        key={k}
        onClick={() => onChange(k)}
        data-testid={`${testId}-${k}`}
        className={`rounded px-2 py-0.5 text-[11px] transition-colors ${value === k ? 'bg-white/15 text-white' : 'text-neutral-500 hover:text-neutral-300'}`}
      >
        {l}
      </button>
    ))}
  </div>
);
